import { Avatar, ClickAwayListener, List, ListItem, ListItemAvatar, ListItemText, Paper, Popper } from '@mui/material';
import { withStyles, WithStyles } from "@mui/styles";
import * as api from "api/Core";
import { SpinnerIndicator } from 'components/CallServer';
import HtmlUtils from 'lib/HtmlUtils';
import * as React from 'react';
import { IOtherListProps, IOtherProps, IOtherState, othersStyles } from './OthersCommon';

//////////////////////////////////////////////////////////////////////////////////////

type OtherListProps = IOtherListProps & WithStyles<typeof othersStyles>;

class OtherPeopleListComponent extends React.PureComponent<OtherListProps, IOtherState> {

    constructor(props: OtherListProps) {
        super(props);
        this.state = { list: null };
    }

    render() {
        if (!this.state.list) {
            api.getNotificationOtherPeople(this.props.groupId)
                .then((list) => {
                    this.setState({ list });
                });
        }

        return (
            <ClickAwayListener
                onClickAway={() => this.props.onClose()}
            >

                <List
                    classes={{ root: this.props.classes.listRoot }}
                    disablePadding
                >
                    {
                        this.state.list == null
                            ? <ListItem><SpinnerIndicator /></ListItem>
                            : this.state.list.map((v, index) => (
                                <ListItem
                                    key={index}
                                    button
                                    disableGutters
                                    style={{ padding: 0 }}
                                    onClick={() => HtmlUtils.openUrlInNewWindow(`/user/profile/${v.userId}`, v.userId)}
                                >
                                    <ListItemAvatar style={{ minWidth: 30 }}>
                                        <Avatar src={v.thumbnailUrl} title={v.name} style={{ height: 24, width: 24 }} />
                                    </ListItemAvatar>
                                    <small><ListItemText primary={v.name} primaryTypographyProps={{ variant: "body2" }} /></small>
                                </ListItem>
                            ))
                    }
                </List>

            </ClickAwayListener>
        );
    }
}
export const OtherPeopleList = withStyles(othersStyles)(OtherPeopleListComponent);

//////////////////////////////////////////////////////////////////////////////////////

type OtherProps = IOtherProps & WithStyles<typeof othersStyles>;

class OtherPeopleComponent extends React.PureComponent<OtherProps, IOtherState> {

    constructor(props: OtherProps) {
        super(props);
        this.state = { list: null };
    }

    render() {
        if (!this.state.list) {
            api.getNotificationOtherPeople(this.props.groupId)
                .then((list) => {
                    this.setState({ list });
                });
        }

        return (
            <Popper
                disablePortal={false}
                open={true}
                anchorEl={this.props.anchor}
                style={{ zIndex: 130000 }}
            >
                <ClickAwayListener
                    onClickAway={() => this.props.onClose()}
                >

                    <Paper>
                        <List
                            classes={{ root: this.props.classes.listRoot }}
                        >
                            {
                                this.state.list == null
                                    ? <ListItem><SpinnerIndicator /></ListItem>
                                    : this.state.list.map((v, index) => (
                                        <ListItem
                                            key={index}
                                            button
                                            onClick={() => HtmlUtils.openUrlInNewWindow(`/user/profile/${v.userId}`, v.userId)}
                                        >
                                            <Avatar src={v.thumbnailUrl} title={v.name} />
                                            <ListItemText primary={v.name} primaryTypographyProps={{ variant: "body2" }} />
                                        </ListItem>
                                    ))
                            }
                        </List>
                    </Paper>

                </ClickAwayListener>
            </Popper >
        );
    }
}

export default withStyles(othersStyles)(OtherPeopleComponent);

